import { createSlice } from "@reduxjs/toolkit";

interface CartState {
  items: any[];
}

const initialState: CartState = {
  items: [],
};

const UserSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    addItem: (state, action) => {
      const { dish, variant } = action.payload;
      const exists = state.items.find((item) => item.id === variant.id);
      if (!exists) {
        state.items.push({
          description: `${dish.name} (${variant.name})`,
          restaurant_dish_id: dish.id,
          restaurant_dish_variant_id: variant.id,
          quantity: 1,
          amount: variant.price,
        });
      }
    },
    removeItem: (state, action) => {
      const { variant } = action.payload;
      state.items = state.items.filter((item) => item.restaurant_dish_variant_id !== variant.id);
    },
    removeByVariantId: (state, action) => {
      const { variantId } = action.payload;
      state.items = state.items.filter((item) => item.restaurant_dish_variant_id !== variantId);
    },
    resetCart: (state) => {
      state.items = [];
    },
  },
});

export const { addItem, removeItem, removeByVariantId, resetCart } = UserSlice.actions;
export default UserSlice.reducer;
